import React from 'react';
import { DeleteResolutionToOrderApi } from 'src/api/modules/orderOfTheDay';
import BaseModal from 'src/common/components/Modal';
import notice from 'src/common/components/Notice';

const DeleteResolutions = ({ open, onClose, onSuccess, resolutions, themes }) => {
	const deleteResolutions = () => {
		const resAndThem = resolutions.concat(themes);
		const newObj = { resoluciones: resAndThem };
		DeleteResolutionToOrderApi.post(newObj)
			.then((response) => {
				if (response) {
					onSuccess(
						'Se Eliminaron las Resoluciones/Temas Seleccionados',
						'success'
					);
				}
			})
			.catch((e) => {
				if (e) notice('Ha Ocurrido un Problema con la Solicitud', 'error');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Eliminar Resoluciones"
			confirmLabel="Si, eliminar"
			onConfirm={deleteResolutions}
			onClose={onClose}
			onCancel={onClose}
		>
			<h5>¿Seguro que desea eliminar las resoluciones seleccionadas?</h5>
		</BaseModal>
	);
};

export default DeleteResolutions;
